const ReservationSegmentEvent = {
  fetch: 'reservation-segment/fetch',
  onEdit: 'reservation-segment/on-edit'
}

export default ReservationSegmentEvent
